import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState, useEffect } from 'react';
import { filter, omit, pick } from '@cullylarson/f';
import { paramUrl } from '@@client/lib/url';
var searchStorageKey = 'wkr:search';
var searchVersion = 1; // if the structure of the saved data ever changes, increment this value

var getSearch = function getSearch() {
  var raw = sessionStorage.getItem(searchStorageKey);
  return raw ? JSON.parse(raw) : {};
};

var saveSearch = function saveSearch(data) {
  data = _objectSpread(_objectSpread({}, data), {}, {
    version: searchVersion
  });
  sessionStorage.setItem(searchStorageKey, JSON.stringify(data));
};

var saveSearchKey = function saveSearchKey(key, value) {
  var data = getSearch();
  saveSearch(_objectSpread(_objectSpread({}, data), {}, _defineProperty({}, key, value)));
};

var getSearchKey = function getSearchKey(key) {
  var data = getSearch();
  return data[key] || null;
};

export var getSearchUrl = function getSearchUrl(params) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/parts';
  params = filter(Boolean, params);
  return params.q ? paramUrl(baseUrl, pick(['q'], params)) : paramUrl(baseUrl, omit(['q'], params));
};
export var saveLastSearch = function saveLastSearch(_ref) {
  var part = _ref.part,
      year = _ref.year,
      make = _ref.make,
      model = _ref.model,
      app = _ref.app,
      q = _ref.q,
      s = _ref.s,
      o = _ref.o,
      p = _ref.p;
  var lastSearch = {
    part: part,
    year: year,
    make: make,
    model: model,
    app: app,
    q: q,
    s: s,
    o: o,
    p: p
  };
  saveSearchKey('lastSearch', lastSearch);
};

var getLastSearch = function getLastSearch() {
  return getSearchKey('lastSearch');
};

export var useLastSearch = function useLastSearch() {
  var _useState = useState(null),
      lastSearch = _useState[0],
      setLastSearch = _useState[1];

  useEffect(function () {
    setLastSearch(getLastSearch());
  }, []);
  return lastSearch;
};